module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fullContainer surveyPage",
    attrs: {
      "grid-list-xl": "",
      "id": "manu_385889803"
    }
  }, [(_vm.canView == false) ? _c('p', [_vm._v("Please pass through credits to use Survey Form")]) : _vm._e(), _vm._v(" "), (_vm.fncCheckCreated()) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncCheckSuccessMessage())
    }
  }) : _vm._e(), _vm._v(" "), _c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.loading == true) ? _c('img', {
    staticClass: "imgLoader",
    staticStyle: {
      "width": "75px"
    },
    attrs: {
      "src": require("../shared/assets/images/bwh-loader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.formValid == false) ? _c('h2', [_c('center', [_vm._v("Invalid Token Authorization")])], 1) : _vm._e(), _vm._v(" "), (_vm.kamValid == false) ? _c('h2', [_c('center', [_vm._v("Agent User not loaded on system")])], 1) : _vm._e(), _vm._v(" "), (_vm.formExist == false && _vm.isCreated == true) ? _c('h2', [_c('center', [_vm._v("The Service Form does not exist")])], 1) : _vm._e(), _vm._v(" "), (_vm.formExist == true && _vm.kamValid == true && _vm.formValid == true && _vm.loading == false && _vm.canView == true && !_vm.fncCheckCreated()) ? _c('v-form', {
    staticClass: "surveyForm"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.customerSurveyType == '' || _vm.acceptedType == false) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.processData.name))])]) : _vm._e(), _vm._v(" "), (_vm.customerSurveyType == '' || _vm.acceptedType == false) ? _c('v-flex', [_c('p', [_c('br'), _vm._v("Please select which type of service you require:")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.customerSurveyTypes,
      "placeholder": "Survey Type",
      "item-value": "id",
      "item-text": "text",
      "solo": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckPaymentPopup()
      }
    },
    model: {
      value: (_vm.customerSurveyType),
      callback: function($$v) {
        _vm.customerSurveyType = $$v
      },
      expression: "customerSurveyType"
    }
  }), _vm._v(" "), (_vm.serviceText != '') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncFormatText())
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.serviceText != '') ? _c('v-btn', {
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncStartForm()
      }
    }
  }, [_vm._v("Next")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 grey lighten-2"
  }, [_vm._v("Callout Fee - Payment")]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncFormatPopup())
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "background-color": "#333 !important",
      "background": "#333 !important"
    },
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("I accept")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.customerSurveyType != '' && _vm.acceptedType == true) ? _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.processData.name))])]) : _vm._e(), _vm._v(" "), (_vm.customerSurveyType != '' && _vm.acceptedType == true) ? _c('v-flex', {
    staticClass: "floatRightElement",
    attrs: {
      "lg4": ""
    }
  }, [(_vm.loading == false) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncReset()
      }
    }
  }, [_vm._v("Clear and start again")]) : _vm._e(), _vm._v(" "), (_vm.loading == false) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.surveyValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveSurvey()
      }
    }
  }, [_vm._v("Submit Request")]) : _vm._e(), _c('br'), _vm._v(" "), _c('small', [_vm._v("Please fill in all compulsory fields")]), _c('small', {
    staticStyle: {
      "color": "red !important"
    }
  }, [_vm._v("*  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.customerSurveyType != '' && _vm.acceptedType == true) ? _c('v-tabs', {
    staticClass: "surveyTabs",
    attrs: {
      "slider-color": "grey"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(this.storeInfoBranch == '' || this.clientInfoContact == '' || this.clientInfoCell == '' || this.clientInfoCoName == '' || this.clientInfoCoSurname == '' || this.clientInfoEmail == '' || this.clientPmoc == '' || this.clientInfoTel == '') ? _c('v-tab', {
    key: 1,
    ref: "details",
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Client Info "), _c('span', {
    staticStyle: {
      "padding-left": "4px",
      "color": "red",
      "font-size": "15px"
    }
  }, [_vm._v("*")])]) : _c('v-tab', {
    key: 1,
    ref: "details",
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Client Info "), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('v-tab', {
    key: 2,
    ref: "upload",
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Upload Samples, images, plans etc.")]), _vm._v(" "), _vm._l((_vm.processData.tabs), function(item, i) {
    return _c('v-tab', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.fncCheckTabDisplay(item)),
        expression: "fncCheckTabDisplay( item )"
      }],
      key: i + 3,
      ref: "fncGetDynamicRef(i)",
      refInFor: true,
      staticClass: "tab",
      attrs: {
        "id": _vm.fncGetDynamicRef(i),
        "ripple": ""
      }
    }, [_vm._v(_vm._s(_vm.processData.tabs[i].name)), _c('span', {
      staticStyle: {
        "padding-left": "4px"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.fncGetDynamicAsterix(i))
      }
    })])
  }), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4 tabItem",
    attrs: {
      "transition": false,
      "reverse-transition": false
    }
  }, [_c('v-container', {
    staticClass: "fullContainerSub",
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.objAuthorize.manufacturer == '385889803') ? _c('div', {
    staticClass: "mobileServiceForm"
  }, [(_vm.customerSurveyType == '') ? _c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "float": "left",
      "width": "auto !important",
      "line-height": "45px",
      "margin-right": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Select type of service:")]) : _c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "float": "left",
      "width": "auto !important",
      "line-height": "45px",
      "margin-right": "5px"
    }
  }, [_vm._v("Select type of service:")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "items": _vm.customerSurveyTypes,
      "item-value": "id",
      "item-text": "text",
      "rules": _vm.rules,
      "placeholder": "Survey Type",
      "solo": "",
      "outline": ""
    },
    model: {
      value: (_vm.customerSurveyType),
      callback: function($$v) {
        _vm.customerSurveyType = $$v
      },
      expression: "customerSurveyType"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.$router.history.current.query.agentEmail != undefined) ? _c('div', {
    staticClass: "screenTip",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px",
      "margin-left": "2% !important",
      "width": "97% !important"
    }
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" Please select a user from the dropdown below.  Deselect the role if it is not required.\n                  ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.processData.process_roles), function(item, i) {
    return (item != 'NaN' && _vm.$router.history.current.query.agentEmail != undefined) ? _c('v-flex', {
      attrs: {
        "lg12": ""
      }
    }, [_c('div', {
      staticClass: "validHolder"
    }, [_c('v-switch', {
      ref: _vm.fncGenerateSwitchRef(i),
      refInFor: true,
      attrs: {
        "label": _vm.fncCheckRoleLabel(item)
      },
      on: {
        "change": function($event) {
          return _vm.fncCheckValid()
        }
      },
      model: {
        value: (_vm.roleSwitches[i]),
        callback: function($$v) {
          _vm.$set(_vm.roleSwitches, i, $$v)
        },
        expression: "roleSwitches[i]"
      }
    })], 1), _vm._v(" "), (item != 'NaN') ? _c('v-select', {
      ref: _vm.fncGenerateRef(i),
      refInFor: true,
      staticClass: "dropdown",
      attrs: {
        "items": _vm.fncGetItems(item),
        "placeholder": "Select Users",
        "item-value": "id",
        "item-text": "fullname",
        "solo": "",
        "multiple": "",
        "autocomplete": ""
      },
      on: {
        "input": _vm.fncCheckValid
      },
      model: {
        value: (_vm.linkedUsers),
        callback: function($$v) {
          _vm.linkedUsers = $$v
        },
        expression: "linkedUsers"
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', [_vm._v("Customer Details")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoCoName == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Customer’s name")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer’s name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Co Name",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoCoName),
      callback: function($$v) {
        _vm.clientInfoCoName = $$v
      },
      expression: "clientInfoCoName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoCoSurname == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Customer’surname")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer’s surname")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Co Name",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoCoSurname),
      callback: function($$v) {
        _vm.clientInfoCoSurname = $$v
      },
      expression: "clientInfoCoSurname"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoEmail == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Customer’s email address")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer’s email address")]), _vm._v(" "), (_vm.$router.history.current.query.client_email != undefined) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px",
      "min-height": "40px",
      "border": "1px solid #f1f1f1",
      "margin": "0 5px",
      "letter-spacing": "0.14px",
      "color": "#ccc",
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.clientInfoEmail))]) : _vm._e(), _vm._v(" "), (_vm.$router.history.current.query.client_email == undefined) ? _c('v-text-field', {
    attrs: {
      "placeholder": "Email",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoEmail),
      callback: function($$v) {
        _vm.clientInfoEmail = $$v
      },
      expression: "clientInfoEmail"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoEmail == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Customer’s email address")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer’s email address")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Email",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoEmail),
      callback: function($$v) {
        _vm.clientInfoEmail = $$v
      },
      expression: "clientInfoEmail"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoTel == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Customer’s mobile no.")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer’s mobile no.")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Tel",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoTel),
      callback: function($$v) {
        _vm.clientInfoTel = $$v
      },
      expression: "clientInfoTel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Company",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.$router.history.current.query.agentEmail != undefined) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project")]) : _vm._e(), _vm._v(" "), (_vm.$router.history.current.query.agentEmail != undefined) ? _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectList,
      "placeholder": "Project",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.project_item),
      callback: function($$v) {
        _vm.project_item = $$v
      },
      expression: "project_item"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mobileServiceForm",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer's Address")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Street No. and Name",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientAddress),
      callback: function($$v) {
        _vm.clientAddress = $$v
      },
      expression: "clientAddress"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Complex Name and No.",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientAddressTwo),
      callback: function($$v) {
        _vm.clientAddressTwo = $$v
      },
      expression: "clientAddressTwo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Suburb",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientSuburb),
      callback: function($$v) {
        _vm.clientSuburb = $$v
      },
      expression: "clientSuburb"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Town",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientTown),
      callback: function($$v) {
        _vm.clientTown = $$v
      },
      expression: "clientTown"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Province",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientProvince),
      callback: function($$v) {
        _vm.clientProvince = $$v
      },
      expression: "clientProvince"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Postal Code",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientPostalCode),
      callback: function($$v) {
        _vm.clientPostalCode = $$v
      },
      expression: "clientPostalCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mobileServiceForm",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', [_vm._v("Contact Person Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "contactpersonswitch"
  }, [_c('div', {
    staticClass: "mobileServiceForm"
  }, [_c('label', {
    staticStyle: {
      "float": "right",
      "width": "auto !important"
    }
  }, [_vm._v("Contact person and customer are the same.")]), _vm._v(" "), _c('v-switch', {
    staticStyle: {
      "float": "left",
      "width": "auto",
      "margin": "0 5px"
    },
    on: {
      "change": _vm.fncCheckDetails
    },
    model: {
      value: (_vm.detailsSame),
      callback: function($$v) {
        _vm.detailsSame = $$v
      },
      expression: "detailsSame"
    }
  })], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoContact == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Contact person")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Contact person")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Contact",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoContact),
      callback: function($$v) {
        _vm.clientInfoContact = $$v
      },
      expression: "clientInfoContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientInfoCell == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Contact person’s mobile no.")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Contact person’s mobile no.")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Cell",
      "rules": _vm.rules,
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientInfoCell),
      callback: function($$v) {
        _vm.clientInfoCell = $$v
      },
      expression: "clientInfoCell"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(_vm.clientPmoc == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Preferred method of contact")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Preferred method of contact")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.pmocList,
      "rules": _vm.rules,
      "placeholder": "Prefered Method of Contact",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "outline": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.clientPmoc),
      callback: function($$v) {
        _vm.clientPmoc = $$v
      },
      expression: "clientPmoc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mobileServiceForm",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.$router.history.current.query.agentEmail != undefined) ? _c('div', [(_vm.storeInfoBranch == '') ? _c('label', {
    staticClass: "blackLabel"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" Store")]) : _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Store")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.branchList,
      "rules": _vm.rules,
      "placeholder": "Store Name",
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "outline": ""
    },
    on: {
      "input": _vm.fncCheckValid
    },
    model: {
      value: (_vm.storeInfoBranch),
      callback: function($$v) {
        _vm.storeInfoBranch = $$v
      },
      expression: "storeInfoBranch"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Message:")]), _vm._v(" "), (_vm.$router.history.current.query.agentEmail != undefined) ? _c('v-text-field', {
    staticStyle: {
      "height": "133px !important"
    },
    attrs: {
      "placeholder": "Message",
      "rules": _vm.rules,
      "rows": "10",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientMessage),
      callback: function($$v) {
        _vm.clientMessage = $$v
      },
      expression: "clientMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$router.history.current.query.agentEmail == undefined) ? _c('v-text-field', {
    staticStyle: {
      "height": "155px !important"
    },
    attrs: {
      "placeholder": "Message",
      "rules": _vm.rules,
      "rows": "10",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.clientMessage),
      callback: function($$v) {
        _vm.clientMessage = $$v
      },
      expression: "clientMessage"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "blackButton",
    on: {
      "click": function($event) {
        return _vm.fncSetUploadTab()
      }
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": "",
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }), _vm._v(" "), _vm._l((_vm.processData.process_roles), function(item, i) {
    return (_vm.$router.history.current.query.agentEmail != undefined && _vm.processData.process_roles[0] != '' && _vm.processData.process_roles[i] != 'NaN') ? _c('v-flex', {
      attrs: {
        "lg3": "",
        "xs12": "",
        "sm3": "",
        "md4": ""
      }
    }) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    attrs: {
      "transition": false,
      "reverse-transition": false
    }
  }, [_c('v-container', {
    staticClass: "fullContainerSub",
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "mobileServiceFormMini"
  }, [_c('h3', [_vm._v("Upload Files")]), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    staticStyle: {
      "padding-top": "30px !important",
      "padding-bottom": "30px !important"
    },
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Click to Add Files")])]), _vm._v(" "), _c('p', {
    staticClass: "filerules"
  }, [_vm._v(" Maximum file size allowed: "), _c('strong', [_vm._v(_vm._s(_vm.systemSettings[0].max_upload_size) + "MB")]), _c('br'), _vm._v("\n                      File types supported: "), _c('strong', [_vm._v(_vm._s(_vm.systemSettings[0].allowed_file_types.replace(/,./g, ', .')))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), _c('div', {
    staticClass: "mobileServiceFormMini"
  }, [_c('small', [_c('strong', [_vm._v("Disclaimer: ")]), _c('br'), _vm._v("Please note larger files will take longer to upload. Please wait for files to finish uploading. "), _c('br'), _vm._v("Should your file sizes exceed the allotted file size, kindly discuss this with your Representative.")])]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 attachmentList",
    staticStyle: {
      "margin-top": "20px",
      "float": "left",
      "clear": "both"
    },
    attrs: {
      "headers": _vm.headers,
      "items": _vm.surveyFiles,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(_vm.$router.history.current.query.agentEmail != undefined) ? _c('td', {
          attrs: {
            "width": "60%"
          }
        }, [_c('a', [_vm._v(_vm._s(props.item.original_filename))])]) : _c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('a', [_vm._v(_vm._s(props.item.original_filename))])]), _vm._v(" "), (_vm.$router.history.current.query.agentEmail != undefined) ? _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_c('v-select', {
          staticClass: "surveyAttachment",
          staticStyle: {
            "height": "35px !important"
          },
          attrs: {
            "items": _vm.attachmentCategories,
            "label": "Attachment Category",
            "item-value": "id",
            "item-text": "name",
            "solo": "",
            "single-line": ""
          },
          model: {
            value: (props.item.category),
            callback: function($$v) {
              _vm.$set(props.item, "category", $$v)
            },
            expression: "props.item.category"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveImage(props.index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])]
      }
    }], null, false, 4100269020)
  }), _vm._v(" "), (_vm.busyUploading == 1) ? _c('p', {
    staticClass: "waitingUpload"
  }, [_c('strong', [_vm._v("Uploading... Please wait...")])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "blackButton",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetDetailsTab()
      }
    }
  }, [_vm._v("Previous")]), _vm._v(" "), (_vm.processData.tabs.length > 0 && _vm.fncHasDynamicNext()) ? _c('v-btn', {
    staticClass: "blackButton",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetDynamicTabNext(99)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.processData.tabs), function(item, i) {
    return _c('v-tab-item', {
      key: i + 3,
      staticClass: "pl-4 pr-4 pt-4 pb-4",
      attrs: {
        "transition": false,
        "reverse-transition": false
      }
    }, [_c('v-container', {
      staticClass: "fullContainerSub",
      attrs: {
        "grid-list-xl": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_vm._l((_vm.processData.tabs[i].form), function(item, n) {
      return _c('v-flex', {
        class: _vm.fncCheckClass(_vm.processData.tabs[i].form[n].type),
        attrs: {
          "lg3": "",
          "xs12": "",
          "sm6": "",
          "md4": ""
        }
      }, [(_vm.processData.tabs[i].form[n].type == 'header') ? _c('h4', {
        staticStyle: {
          "display": "block",
          "clear": "both"
        }
      }, [_vm._v(_vm._s(_vm.processData.tabs[i].form[n].label))]) : _vm._e(), _vm._v(" "), (_vm.processData.tabs[i].form[n].type != 'header' && _vm.processData.tabs[i].form[n].type != 'yesno') ? _c('label', {
        staticClass: "blackLabel"
      }, [(_vm.processData.tabs[i].form[n].required == 'true') ? _c('span', [_c('span', {
        staticStyle: {
          "color": "red",
          "font-size": "15px"
        }
      }, [_vm._v("*")]), _vm._v(" ")]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.processData.tabs[i].form[n].label))]) : _vm._e(), _vm._v(" "), (_vm.processData.tabs[i].form[n].type != 'header' && _vm.processData.tabs[i].form[n].type == 'yesno') ? _c('label', {
        staticClass: "blackLabel",
        staticStyle: {
          "float": "right",
          "width": "85% !important",
          "padding-top": "5px !important"
        }
      }, [(_vm.processData.tabs[i].form[n].required == 'true') ? _c('span', [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(_vm.processData.tabs[i].form[n].label))]) : _vm._e(), _vm._v(" "), (_vm.processData.tabs[i].form[n].type == 'input') ? _c('v-text-field', {
        attrs: {
          "placeholder": _vm.processData.tabs[i].form[n].label,
          "rules": _vm.rules,
          "single-line": "",
          "solo": ""
        },
        on: {
          "input": [function($event) {
            return _vm.fncValidateErf(_vm.processData.tabs[i].form[n])
          }, _vm.fncCheckValid]
        },
        model: {
          value: (_vm.processData.tabs[i].form[n].value),
          callback: function($$v) {
            _vm.$set(_vm.processData.tabs[i].form[n], "value", $$v)
          },
          expression: "processData.tabs[i].form[n].value"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.processData.tabs[i].form[n].type == 'input' && _vm.duplicateErf == true && _vm.processData.tabs[i].form[n].label == 'Erf Number') ? _c('small', {
        staticStyle: {
          "color": "red",
          "font-weight": "bold"
        }
      }, [_vm._v("Duplicate Erf Number.")]) : _vm._e(), _vm._v(" "), (_vm.processData.tabs[i].form[n].type == 'select') ? _c('v-select', {
        staticClass: "dropdown",
        attrs: {
          "items": _vm.fncGetValues(_vm.processData.tabs[i].form[n].values),
          "placeholder": _vm.processData.tabs[i].form[n].label,
          "solo": "",
          "outline": ""
        },
        on: {
          "input": _vm.fncCheckValid
        },
        model: {
          value: (_vm.processData.tabs[i].form[n].value),
          callback: function($$v) {
            _vm.$set(_vm.processData.tabs[i].form[n], "value", $$v)
          },
          expression: "processData.tabs[i].form[n].value"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.processData.tabs[i].form[n].type == 'yesno') ? _c('v-switch', {
        staticStyle: {
          "width": "15% !important"
        },
        on: {
          "change": _vm.fncCheckValid
        },
        model: {
          value: (_vm.processData.tabs[i].form[n].value),
          callback: function($$v) {
            _vm.$set(_vm.processData.tabs[i].form[n], "value", $$v)
          },
          expression: "processData.tabs[i].form[n].value"
        }
      }) : _vm._e()], 1)
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "lg12": ""
      }
    }, [_c('v-btn', {
      staticClass: "blackButton",
      staticStyle: {
        "float": "left"
      },
      on: {
        "click": function($event) {
          return _vm.fncSetDynamicTabPrevious(i)
        }
      }
    }, [_vm._v("Previous")]), _vm._v(" "), (_vm.processData.tabs.length > 0 && _vm.fncCanGoNext() == true) ? _c('v-btn', {
      staticClass: "blackButton",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.fncSetDynamicTabNext(i)
        }
      }
    }, [_vm._v("Next")]) : _vm._e()], 1)], 2)], 1)], 1)
  })], 2) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}